export default __webpack_public_path__ + "static/summer_containers59-b90a140e263ac2c937bd95af20d7e534.webp";